export default __webpack_public_path__ + "static/media/gb-eng.7d041eb4.svg";